import { uniqueId } from 'lodash-es'

/**
 * @description: 数据类型精准判断
 * @param {*} keyVal 要判断的数据
 * @return {*} 类型名称的字符串（小写）： number、string、boolean、null、undefined、object、symbol...
 */
export function typeOf (keyVal: any) {  // 精准判断数据类型
  // 数据类型判断
  return Object.prototype.toString
    .call(keyVal)
    .replace('[object ', '')
    .replace(']', '')
    .toLowerCase()
}

export function S4 () {
  // 生成唯一数 
  // 0x   表示16进制数据的开头
  const s4 = (((1 + Math.random()) * 0x10000) | 0).toString(16)
  return Symbol(s4)
}

export function getUUID (prefix?: string) {
  if(prefix) return uniqueId(prefix)
  return window?.crypto?.randomUUID?.() || uniqueId()
}

export function cloneDeep (value) {
  // 深拷贝
  return cloneDeep(value) // 直接使用lodash的方法了
}
/**
 * @description: 也为深拷贝，数组的额外值也能被拷贝，列：[1, ids: Symbol(13359)],可以拷贝出数组中的Symbol
 * @param {*} obj 需要进行拷贝的数据
 * @return {*} 深拷贝完成后的数据
 */
export function deepCopy(obj) {
  // 深拷贝
  let copyObj
  const isObject = function (obj) {
    const result =
      (typeof obj === 'object' || typeof obj === 'function') &&
      typeof obj != null
    return result
  }
  if (!isObject(obj)) {
    throw Error('不是一个对象')
  }
  if (obj === null) {
    copyObj = null
  } else {
    const isArray = Array.isArray(obj)
    copyObj = isArray ? [] : {} // 判断传入的obj是一个数组还是一个对象
  }
  for (const key in obj) {
    copyObj[key] = isObject(obj[key]) ? deepCopy(obj[key]) : obj[key]
  }
  return copyObj
}


export default {
  // 这是要绑顶方法
  cloneDeep,
  deepCopy,
}
